'use strict';

angular.module('shiftTraderApp')
  .service('NotesOverlayContextService', ['storage', '$state', '$rootScope', '$injector', '$location', '$timeout', 'TimeService', 'NotesQueryManagementService', 'EventStreamsService',
    function(storage, $state, $rootScope, $injector, $location, $timeout, TimeService, NotesQueryManagementService, EventStreamsService) {
      var currentContext = null;

      var stream = EventStreamsService.getStream(EventStreamsService.names.notesOverlayContext);

      var contextHistory = [];

      function getContext() {
        return currentContext;
      }

      function setContext(context) {
        if (contextHistory.length > 5) {
          contextHistory.shift();
        }

        if (!lodash.isNull(currentContext)) {
          contextHistory.push(currentContext);
        }


        currentContext = context;
        stream.push('context', currentContext);
      }

      function shiftDateContext(numDays) {
        var initCtx = getContext();
        var newCtxStart, newCtxEnd;

        if (numDays > 0) {
          newCtxStart = TimeService.getDayTwixFromDate(moment(initCtx.dates.start).add({hours: 12, days: numDays}));
          newCtxEnd = TimeService.getDayTwixFromDate(moment(initCtx.dates.end).add({hours: 12, days: numDays}));
        } else if (numDays < 0) {
          newCtxStart = TimeService.getDayTwixFromDate(moment(initCtx.dates.start).subtract({hours: 12, days: (numDays + 1) * -1}));
          newCtxEnd = TimeService.getDayTwixFromDate(moment(initCtx.dates.end).subtract({hours: 12, days: (numDays + 1) * -1}));
        }

        setContext(lodash.merge(initCtx, {
          dates: {
            start: newCtxStart.start,
            end: newCtxEnd.start
          }
        }))
      }

      function setDateContext(mmnt, tags) {
        var twx = TimeService.getDayTwixFromDate(mmnt);
        var tmp = {
          obj: 'date',
          dates: {
            start: twx.start,
            end: twx.end
          }
        };

        var today = TimeService.getBeginningOfDayFromDate(TimeService.getNowInStoreTime());
        if (!today.isSame(mmnt, 'minute')) {
          tmp.custom = true;
        }

        if (tags) {
          tmp.tags = tags;
        }

        setContext(tmp);
      }

      function setUserContext(userId, opts) {
        var ctx = {
          obj: 'User',
          obj_id: userId.toString()
        };

        if (opts) {
          ctx = lodash.merge(ctx, opts);
        }

        setContext(ctx);
      }

      function setPositionContext(posId, opts) {
        var ctx = {
          obj: 'Position',
          obj_id: posId.toString()
        };

        if (opts) {
          ctx = lodash.merge(ctx, opts);
        }

        setContext(ctx);
      }

      function setWorkPeriodContext(wp) {
        setContext({
          obj: 'WorkPeriod',
          obj_id: wp.id,
          custom: true,
          cache_locale: {
            start: wp.start_time,
            end: wp.end_time
          }
        });
      }

      function setHomeContext() {
        setContext({
          obj: 'Home'
        });
      }

      function setLearnContext() {
        setContext({
          obj: 'Learn'
        });
      }

      function setMostRecentContext() {
        setContext({
          obj: 'Recent'
        });
      }

      function setNoteContext(id) {
        setContext({
          obj: 'Note',
          id: id
        });
      }

      setDateContext(TimeService.getBeginningOfDayFromDate(TimeService.getNowInStoreTime()));

      return {
        shiftDateContext: shiftDateContext,
        setUserContext: setUserContext,
        setPositionContext: setPositionContext,
        setDateContext: setDateContext,
        setWorkPeriodContext: setWorkPeriodContext,
        setHomeContext: setHomeContext,
        setLearnContext: setLearnContext,
        setMostRecentContext: setMostRecentContext,
        setNoteContext: setNoteContext,
        getContext: getContext
      };

    }]);
